import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const getIconButtonStyle = (color: string) => css`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${theme.spacing(0.5)};
  border-radius: ${theme.borderRadius.small};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${color};

  &&:focus,
  &&:focus-visible,
  &&:focus-within {
    outline: none;
  }

  &:hover,
  &:active:not([aria-disabled='true']) {
    background-color: ${theme.colors.neutral[10]};

    & svg {
      color: ${color};
    }
  }
`;
